import { render, staticRenderFns } from "./BannerSharesComponent.vue?vue&type=template&id=b8251268"
import script from "./BannerSharesComponent.vue?vue&type=script&lang=js"
export * from "./BannerSharesComponent.vue?vue&type=script&lang=js"
import style0 from "./BannerSharesComponent.vue?vue&type=style&index=0&id=b8251268&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports